import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import {
  IBodyCreateEstimate,
  IBodyCreatePrice,
  IParamsGetEstimateList,
  IParamsGetPriceComponent,
  IPayloadDeleteEstimates,
  IPayloadDeletePriceComponent,
  IPrice,
  IPriceComponent,
  IResponseGetEstimate,
  IResponseGetEstimateItems,
  IResponseGetEstimateList,
  IResponseGetPriceComponentList,
  IResponseGetPriceList,
} from '~/utils/interface/estimate';
import { IResponseGetFile } from '~/utils/interface/file';

const urlPriceComponent = `api/admin/estimates/price-component`;

const urlPrice = `api/admin/estimates/price`;
const estimateApi = {
  createPriceComponent(data: IPriceComponent) {
    return axiosClient.post<IApiBaseResponse<IPriceComponent>>(urlPriceComponent, data);
  },
  getPriceComponentList(params: IParamsGetPriceComponent) {
    return axiosClient.get<IApiBaseResponse<IResponseGetPriceComponentList>>(urlPriceComponent, { params });
  },

  updatePriceComponent(id: string, data: IPriceComponent) {
    return axiosClient.put<IApiBaseResponse<IPriceComponent>>(`api/admin/estimates/price-component/${id}`, data);
  },
  deletePriceComponent(data: IPayloadDeletePriceComponent) {
    return axiosClient.delete<IApiBaseResponse<null>>(urlPriceComponent, { data });
  },

  getPriceComponent(id: string) {
    return axiosClient.get<IApiBaseResponse<IPriceComponent>>(`api/admin/estimates/price-component/${id}`);
  },

  createPrice(data: IBodyCreatePrice) {
    return axiosClient.post<IApiBaseResponse<IBodyCreatePrice>>(urlPrice, data);
  },

  getPrice(id: string) {
    return axiosClient.get<IApiBaseResponse<IPrice>>(`api/admin/estimates/price/${id}`);
  },

  getPriceList(params: IParamsGetPriceComponent) {
    return axiosClient.get<IApiBaseResponse<IResponseGetPriceList>>(urlPrice, { params });
  },

  deletePrice(data: IPayloadDeletePriceComponent) {
    return axiosClient.delete<IApiBaseResponse<null>>(urlPrice, { data });
  },

  updatePrice(id: string, data: IPrice) {
    return axiosClient.put<IApiBaseResponse<IBodyCreatePrice>>(`api/admin/estimates/price/${id}`, data);
  },

  getEstimateList(jobId: string | undefined, params: IParamsGetEstimateList) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateList>>(`api/admin/jobs/${jobId}/estimates`, { params });
  },

  getEstimateItems(jobId?: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimateItems>>(
      `api/admin/jobs/${jobId}/estimates/estimate-items`
    );
  },

  createEstimate(jobId: string | undefined, data: IBodyCreateEstimate) {
    return axiosClient.post<IApiBaseResponse<IBodyCreateEstimate>>(`api/admin/jobs/${jobId}/estimates`, data);
  },

  getEstimate(estimateId: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEstimate>>(`api/admin/estimates/${estimateId}`);
  },

  updateEstimate(estimateId: string, data: IBodyCreateEstimate) {
    return axiosClient.put<IApiBaseResponse<IBodyCreateEstimate>>(`api/admin/estimates/${estimateId}`, data);
  },

  deleteEstimate(data: IPayloadDeleteEstimates) {
    return axiosClient.delete<IApiBaseResponse<null>>(`api/admin/estimates`, { data });
  },

  generatePDF(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFile>>(`api/admin/estimates/${id}/generatePDF`);
  },

  sendDocument(id: string, data: any) {
    return axiosClient.post<IApiBaseResponse<null>>(`api/admin/estimates/${id}/sendDocument`, data);
  },

  revokeDocument(id: string) {
    return axiosClient.get<IApiBaseResponse<null>>(`api/admin/estimates/${id}/revokeDocument`);
  },
};

export default estimateApi;
